import Yup from "../validationsLib";

/**
 * Validations rules for the signup page of consutant
 */

export default Yup.object().shape({
  first_name: Yup.string()
    .matches(
      /^[aA-zZ\s]+$/,
      "First name cannot have numbers & special characters."
    )
    .max(30, "User should not enter more than 30 characters in this field.")
    .required("Please enter first name"),

  last_name: Yup.string()
    .matches(
      /^[aA-zZ\s]+$/,
      "Last name cannot have numbers & special characters."
    )
    .max(30, "User should not enter more than 30 characters in this field.")
    .required("Please enter last name"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Please enter email"),

  // userRole: Yup.array()
  //     .of(
  //         Yup.object().shape({
  //             label: Yup.string().required("Please select user role"),
  //             value: Yup.string().required("Please select user role"),
  //         }),
  //     )
  //     .min(1, "Please select user role"),

  // department: Yup.string()
  //     .required('Please enter department'),

  // location: Yup.string()
  //     .required('Please enter location'),

  // project: Yup.array()
  //     .of(
  //         Yup.object().shape({
  //             label: Yup.string().required("Please select project"),
  //             value: Yup.string().required("Please select project"),
  //         }),
  //     )
  //     .min(1, "Please select project"),
});
